import {
  AccountTitleBaseModel,
  AccountingTypeModel,
} from '@/features/master-table/models';
import { z } from 'zod';
import { ExecutionItemModel } from './execution-item';
import { ExpenditureItemModel } from './expenditure-item';

export const ExpenditureCartBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  priorId: z.string().uuid().nullable(),
  subProjectId: z.string().uuid(),
  accountingId: z.string().uuid(),
  accountTitleId: z.string().uuid().nullish(),
  reasonForChange: z.string().nullish(),
  remark: z.string().nullish(),
  desiredAmount: z.number().nullish(),
});

export const ExpenditureCartModel = ExpenditureCartBaseModel.extend({
  accountingType: AccountingTypeModel,
  accountTitle: AccountTitleBaseModel.nullable(),
  expenditureItems: ExpenditureItemModel.array(),
  executionItem: ExecutionItemModel.nullable(),
});

export const ExpenditureCartsModel = ExpenditureCartModel.array();

export const ExpenditureCartFormSchema = ExpenditureCartModel.pick({
  accountingId: true,
  accountTitleId: true,
  reasonForChange: true,
  remark: true,
  desiredAmount: true,
});
